export default __webpack_public_path__ + "static/media/expressjs.efa9c0b4.png";